import {
	FETCH_HOLIDAYS_REQUEST,
	FETCH_HOLIDAYS_SUCCESS,
	FETCH_HOLIDAYS_FAILURE,
} from '../../constants';

const initialState = {
	holidays: [],
	loading: false,
	error: null,
	totalTaskAssignmentsCount: {
		data: null,
		loading: false,
		error: null,
	}
};

const holidayReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_HOLIDAYS_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};

		case FETCH_HOLIDAYS_SUCCESS:
			return {
				...state,
				holidays: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_HOLIDAYS_FAILURE:
			return {
				...state,
				holidays: [],
				loading: false,
				error: action.payload,
			};

		case 'FETCH_TASK_ASSIGNMENTS_COUNT':
			return {
				...state,
				totalTaskAssignmentsCount: {
					...state.totalTaskAssignmentsCount,
					loading: true,
					error: null,
				},
			};

		case 'FETCH_TASK_ASSIGNMENTS_COUNT_SUCCESS':
			return {
				...state,
				totalTaskAssignmentsCount: {
					...state.totalTaskAssignmentsCount,
					data: action.payload,
					loading: false,
					error: null,
				},
			};

		case 'FETCH_TASK_ASSIGNMENTS_COUNT_FAILURE':
			return {
				...state,
				totalTaskAssignmentsCount: {
					...state.totalTaskAssignmentsCount,
					loading: false,
					error: action.payload,
				},
			};
		default:
			return state;
	}
};

export default holidayReducer; 
